module.exports = __webpack_public_path__ + "img/home_screen_login.ddb099c4.png";